export declare const analyticsIdBrand: unique symbol

export type AnalyticsId<Name extends string> = string & {
  readonly [analyticsIdBrand]: Name
}

export type HostId = AnalyticsId<"HostId">

export type InteractionId = AnalyticsId<"InteractionId">

export type CardId = AnalyticsId<"CardId">

export type AttachmentId = AnalyticsId<"AttachmentId">

export type StandardId = AnalyticsId<"StandardId">

export type ImageId = AnalyticsId<"ImageId">

export type GoogleClassId = AnalyticsId<"GoogleClassId">

export function analyticsId<Name extends string>(id: string): AnalyticsId<Name>
export function analyticsId(id: string): string {
  return id
}

export const asHostId = (id: string): HostId => analyticsId<"HostId">(id)

export const asCardId = (id: string): CardId => analyticsId<"CardId">(id)

export const asAttachmentId = (id: string): AttachmentId => analyticsId<"AttachmentId">(id)

export const asImageId = (id: string): ImageId => analyticsId<"ImageId">(id)

export const asStandardId = (id: string): StandardId => analyticsId<"StandardId">(id)

export const asGoogleClassId = (id: string): GoogleClassId => analyticsId<"GoogleClassId">(id)

export type NonEmptyTuple<T> = [T, ...T[]]

// One palette, one type: a second union here would let a new card colour compile at the palette
// and fail at the label site instead.
export type { CardColorType as CardColor } from "../../models/card-stack"

export type AttachmentSource = "upload" | "google" | "dropbox" | "onedrive" | "other" | "link"

export type PickerAttachmentSource = Exclude<AttachmentSource, "link">

export type EditorBlockKind = "bullet-list" | "numbered-list" | "checklist" | "heading"

export type GoogleClassroomTextField = "title" | "value" | "maxPoints"

export type HeadingLevel = number

export type ListKind = "bulleted" | "numbered" | "checklist" | "none"

/**
 * The editing surface that initiated an operation.
 */
export type EditorSurface =
  | "floating-toolbar"
  | "keyboard"
  | "markdown"
  | "link-popover"
  | "add-button"
  | "clipboard"
  | "drag"
  | "file-drop"
  | "card-menu"
  | "node-actions"
  | "google-classroom-sidebar"

const idPrefix = Math.random().toString(36).slice(2, 8)
let idCounter = 0

export function newInteractionId(): InteractionId {
  return analyticsId<"InteractionId">(`${idPrefix}-${(idCounter++).toString(36)}`)
}
